import $ from 'jquery';

//'use strict';

var addressAutocompleteWidget = null;

/**
 * This is called by the Google script, after it's loaded. This is where we
 * initialise and create Google's autocomplte widget, based on our
 * #billing_search INPUT control.
 */
window.createAddressAutocomplete = function createAddressAutocomplete() {
   const searchElement = document.getElementById('billing_search');

   if (addressAutocompleteWidget) {
      console.log('addressAutocompleteWidget has already been created!');
   } else if (!searchElement) {
      //console.log('Missing element: #billing_search');
   } else {
      // Prevent the Enter key from causing a form-submission.
      searchElement.addEventListener('keydown', function (event) {
         //console.log('Preventing the Enter key from causing a form-submission');
         if (event.keyCode === 13) {
            event.preventDefault();
         }
      });

      // Create the Options for the Google Places Autocomplete widget.
      // fields: ['address_components', 'geometry', 'icon', 'name'],
      const defaultCountryCode = document.getElementById('billing_country').value;
      if (!defaultCountryCode) {
         defaultCountryCode = EAPLUS_VARS.default_country;
      }

      const options = {
         componentRestrictions: {
            country: defaultCountryCode
         },
         fields: ['address_components'],
         strictBounds: false,
         types: ['address'],
      };

      // Create the Google Places Autocomplete widget.
      addressAutocompleteWidget = new google.maps.places.Autocomplete(
         searchElement,
         options
      );

      // When the Autocomplete widget raises the place_changed event,
      // call our populateAddressFromAutocomplete() function.
      addressAutocompleteWidget.addListener("place_changed", populateAddressFromAutocomplete);

      // Enable the billing_search input field.
      searchElement.disabled = false;

      setAddressLookupCountryRestriction();
   }
}

   /**
 * Main entry point. Instantiate the Google Places API script and listen for
 * changes of #billing_country
 */
   $(window).on('load', function() {
      // console.log(`EAPLUS_VARS: Load`);

      const searchElement = $('#billing_search');
      if (searchElement.length == 0) {
         //console.log('Missing element: #billing_search');
      } else if (typeof EAPLUS_VARS === 'undefined') {
         // Don't do anything unless EAPLUS_VARS has been passed from the backend
         // using wp_localize_script().
      } else {
         // Keep track of the last time we changed the billing country, so we
         // know if the user has selected a new country, or chosen the same
         // country again.
         EAPLUS_VARS.lastSelectedCountry = null;

         // Disable the address-earch box until the Google scripts have loaded.
         $(searchElement).prop('disabled', true);

         // Uncomment this to verify that your Google Places API Key is coming
         // through into the script properly.
         // console.log(`EAPLUS_VARS: Init: ${EAPLUS_VARS.google_script_url}`);

         // Create a new script element, set the Google Places API URL,
         // with the callback set to our createAddressAutocomplete() function.
         var googleScriptElement = $('<script async />');
         $(googleScriptElement).prop('src', `${EAPLUS_VARS.google_script_url}&callback=window.createAddressAutocomplete`);
         $('head').append(googleScriptElement);

         // WooCommerce triggers the "updated_checkout" event when the customer
         // changes things like the billing country. We use this to change the
         // scope/restrictions for our autocomplete boc, to make the suggested
         // addresses more relevant for the customer.
         $(document.body).on('updated_checkout', function(event) {
            setAddressLookupCountryRestriction();
         });
      }
   });

function setAddressLookupCountryRestriction() {
   var newCountryCode = document.getElementById('billing_country').value;

   // Fallback to our default country code if newCountryCode is blank.
   if (!newCountryCode) {
      newCountryCode = EAPLUS_VARS.default_country;
   }

   // If the country code has changed, set the country restriction on the
   // autocomplete widget and set the input focus to the billing_search
   // text box, so the user can start typing an address.
   if (addressAutocompleteWidget && (EAPLUS_VARS.lastSelectedCountry != newCountryCode)) {
      // console.log(`Setting country restriction: ${newCountryCode}`);

      EAPLUS_VARS.lastSelectedCountry = newCountryCode;
      addressAutocompleteWidget.setComponentRestrictions({ country: newCountryCode });

      //document.getElementById('billing_search').focus();
   }
}

/**
 * Get the current selected billing country code, and fall back to our default
 * country code if, for some reason, it's blank.
 */
function getAddressAutocompleteCountryCode() {
   var countryCode = null;

   const countryCodeElement = document.getElementById('billing_country');
   if (countryCodeElement) {
      countryCode = countryCodeElement.value;
   }

   if (!countryCode) {
      countryCode = EAPLUS_VARS.default_country;
   }

   return countryCode;
}

/**
 * Set all the billing fields to empty strings.
 */
function resetBillingAddress() {
   const billingFields = [
      'billing_address_1',
      'billing_address_2',
      'billing_postcode',
      'billing_city',
      'billing_state'
   ];

   billingFields.forEach(function(billingField) {
      var input = document.getElementById(billingField);
      if (input) {
         input.value = '';
      }
   });

   jQuery('#billing_state').change();
}

/**
 * Scan a Google "place" object for a specific component
 * and return either its short_name or long_name.
 */
function getAddressComponent(place, componentType, componentLength) {
   // const place = addressAutocompleteWidget.getPlace();
   if (!componentLength) {
      componentLength = 'short_name';
   }

   var componentValue = null;
   for (const component of place.address_components) {
      if (component.types[0] == componentType) {
         componentValue = component[componentLength];
         break;
      }
   }

   if (componentValue == null) {
      return '';
   }

   if (componentType == 'street_number') {
      return componentValue + ' ';
   }

   return componentValue;
}

/**
 * Scan the various post code components of a Google place object, pick the
 * first one that has something in it and set the content os #billing_postcode
 */
function setBestPostalCode(place) {
   const postalComponents = [
      'postal_code',
      'postal_code_suffix',
      'postal_code_prefix'
   ];

   var input = document.getElementById('billing_postcode');
   if (input) {
      postalComponents.forEach(function(postalComponent) {
         var autoCompleteValue = getAddressComponent(place, postalComponent);
         if (input.value) {
            // There's already something in the post code box.
         } else if (!autoCompleteValue) {
            // Auto-complete has no suggestion for this field.
         } else {
            input.value = autoCompleteValue;
         }
      });
   }
}


/**
 * See if the state SELECT control has our state by value. If not, see if we can
 * match against an OPTION's label instead.
 */
function setState(state) {
   const selectElement = document.getElementById('billing_state');

   // Try setting the value of the main SELECT element first.
   selectElement.value = state;

   if (state && !selectElement.value) {

      // console.log('Failed to set billing state. Trying to match option by text instead');

      Array.from(selectElement.options).forEach((optionElement) => {
         if (optionElement.text && (optionElement.text == state)) {

            // console.log(`Found: ${state} => ${optionElement.value}`);
            selectElement.value = optionElement.value;
         }
      });
   }
}

/**
 * This is our main handler, which is called each time the user picks an
 * autocomplete suggested address.
 */
function populateAddressFromAutocomplete() {
   // Get the suggested "place" object from the widget.
   const place = addressAutocompleteWidget.getPlace();

   // Uncomment this to see what's in the Google place object.
   // console.log(place);
   // console.log(place.address_components);

   // Set the billing address fields values to empty.
   resetBillingAddress();

   var billingCountryCode = getAddressAutocompleteCountryCode();
   var sublocality = null;

   if (!place) {
      console.log('Invalid / missing place from Google API');
   } else if (billingCountryCode == 'US') {
      if ($.inArray(getAddressComponent(place, 'administrative_area_level_1', 'short_name'), EAPLUS_VARS.excluded_states) >= 0) {
         jQuery('#checkout-notice-state').modal('show');
         resetBillingAddress();
         //return;
      }
      // if (getAddressComponent(place, 'administrative_area_level_1', 'short_name') == 'NY') {
      //    jQuery('#checkout-notice-ny').modal('show');
      // }
      // Special address handling for the USA.
      document.getElementById('billing_address_1').value = getAddressComponent(place, 'street_number') + getAddressComponent(place, 'route', 'long_name');
      document.getElementById('billing_city').value = getAddressComponent(place, 'locality');
      document.getElementById('billing_postcode').value = getAddressComponent(place, 'postal_code');
      document.getElementById('billing_state').value = getAddressComponent(place, 'administrative_area_level_1');
   } else if (billingCountryCode == 'GB') {
      // Special address handling for the United Kingdom (Great Britain).
      document.getElementById('billing_address_1').value = getAddressComponent(place, 'street_number') + getAddressComponent(place, 'route', 'long_name');
      document.getElementById('billing_city').value = getAddressComponent(place, 'locality');
      if (!document.getElementById('billing_city').value) {
         document.getElementById('billing_city').value = getAddressComponent(place, 'postal_town');
      }

      document.getElementById('billing_state').value = getAddressComponent(place, 'administrative_area_level_2', 'long_name');

      setBestPostalCode(place);
   } else {
      for (const component of place.address_components) {
         const componentType = component.types[0];

         switch (componentType) {
            case "street_number":
               document.getElementById('billing_address_1').value = component.long_name;
               break;

            case "route":
               document.getElementById('billing_address_1').value += ' ' + component.short_name;
               break;

            case "sublocality_level_1":
               sublocality = component.long_name;
               break;

            case "locality":
               document.getElementById('billing_address_2').value = component.long_name;
               document.getElementById('billing_city').value = component.long_name;
               break;

            case "postal_town":
               document.getElementById('billing_city').value = component.long_name;
               break;

            case "administrative_area_level_1":
               setState(component.short_name);
               break;

            case "country":
            default:
               // Either an unhandled or unnecessary address component.
               // console.log(componentType);
               // console.log(component);
               break;
         }
      }

      setBestPostalCode(place);
   }

   // If billing state is empty, try pulling it from administrative_area_level_2 instead.
   if (!document.getElementById('billing_state').value.length) {
      document.getElementById('billing_state').value = getAddressComponent(place, 'administrative_area_level_2');
   }

   // Trigger a change on the #billing_state field so that the on-screen
   // state chooser gets updated.
   if (document.getElementById('billing_state').value) {
      jQuery('#billing_state').change();
   }

   // Because we've changed a bunch of the address fields, we need to trigger
   // a re-validate of the form fields.
   jQuery('.validate-required input, .validate-required select').trigger('validate');
}
